import {Api} from "../Api";
import {HttpClient} from "../_http/HttpClient";

export type Company = {
  id: string;
  title: string;
}

export type CreatePayload = {
  title: string;
  file: File;
}

export type UpdatePayload = Partial<CreatePayload>;

export class CompanyAPI {
  static listAsync(): Promise<Company[]> {
    const url: string = Api.getUrl('/company/list')
    return HttpClient.get(url, {});
  }
  static getAsync(id: string): Promise<Company> {
    const url: string = Api.getUrl(`/company/${id}`);
    return HttpClient.get(url, {});
  }

  static createAsync(payload: CreatePayload): Promise<Company> {
    const url: string = Api.getUrl('/company/create');
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('title', payload.title);
    return HttpClient.postFormDataAndGetJson(url, {}, formData);
  }

  static updateAsync(id: string, payload: UpdatePayload): Promise<Company> {
    const url: string = Api.getUrl(`/company/${id}/update`);
    const formData = new FormData();
    if (payload.file)
      formData.append('file', payload.file);

    if (payload.title)
      formData.append('title', payload.title);
    return HttpClient.postFormDataAndGetJson(url, {}, formData);
  }

  static deleteAsync(id: string): Promise<Response> {
    const url: string = Api.getUrl(`/company/${id}`);
    return HttpClient.deleteAndExpectNoContent(url, {}, {});
  }

  static getFileUrl(id: string): string {
    const baseUrl: string = Api.getUrl(`/company/${id}/file`);
    return HttpClient.getUrl(baseUrl, {});
  }
}